{
  "id": "campaign-102",
  "name": "Fine Parterre",
  "seed": "campaign:102",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....ACCA....x",
    "..****CC****..",
    "...t.hCCh.t.x.",
    "......CC......",
    "...t..CC.~t...",
    ".t...CCCC~~.t,",
    "CCCCCCOOCCCCCC",
    ".T.t.CCCC.t.T,",
    "......CC......",
    "......CC......",
    "......CC......",
    "...Y..CC..Y...",
    "......CC......",
    "..............",
    "S............."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 0
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 12
    }
  ],
  "generatorVersion": 3,
  "level": 102,
  "biome": "estate",
  "par": {
    "reel": 5746,
    "push": 4824,
    "selfPropelled": 4512,
    "tractor": 3630,
    "zeroTurn": 3156,
    "fairway": 2052
  },
  "goldTime": {
    "reel": 5296,
    "push": 4590,
    "selfPropelled": 4332,
    "tractor": 3630,
    "zeroTurn": 2951,
    "fairway": 1838
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 8,
      "selfPropelled": 11,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 8
    },
    "gold": {
      "reel": 25,
      "push": 25,
      "selfPropelled": 25,
      "tractor": 0,
      "zeroTurn": 41,
      "fairway": 45
    }
  }
}
